const colorClasses = {
  azure: "bg-azure/15",
  cerulean: "bg-cerulean/15",
  coral: "bg-coral/10",
  cobalt: "bg-cobalt/20",
  ice: "bg-ice/60",
};

const sizeClasses = {
  sm: "w-60 h-60",
  md: "w-[420px] h-[420px]",
  lg: "w-[520px] h-[520px]",
};

/**
 * Absolutely-positioned blurred gradient blob used for ambient hero/CTA backgrounds.
 *
 * @param {Object} props
 * @param {"azure" | "cerulean" | "coral" | "cobalt" | "ice"} props.color - blob color token
 * @param {string} props.position - Tailwind positioning classes (e.g., "-top-24 -left-24")
 * @param {"sm" | "md" | "lg"} [props.size] - blob size
 * @param {"drift" | "drift-reverse" | "none"} [props.animation] - animation preset
 * @param {string} [props.className] - extra classes
 * @returns {import("react").ReactElement}
 */
export function AmbientGlow(props) {
  const { color, position, size = "md", animation = "none", className = "" } = props;

  const animClass =
    animation === "drift"
      ? "animate-drift"
      : animation === "drift-reverse"
        ? "animate-drift-reverse"
        : "";

  return (
    <span
      aria-hidden="true"
      className={`pointer-events-none absolute rounded-full blur-3xl ${colorClasses[color]} ${sizeClasses[size]} ${position} ${animClass} ${className}`.trim()}
    />
  );
}
